var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M473.654,423.72H38.345C17.167,423.72,0,406.553,0,385.375V126.617 c0-21.176,17.167-38.345,38.345-38.345h435.309c21.177,0,38.345,17.169,38.345,38.345v258.758 C511.999,406.553,494.831,423.72,473.654,423.72z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 220.688,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 23.54
  }), /*#__PURE__*/React.createElement("rect", {
    y: 244.227,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 23.54
  }), /*#__PURE__*/React.createElement("rect", {
    y: 267.767,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 23.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.69,
    y: 88.277,
    style: {
      fill: "#FFE15A"
    },
    width: 23.54,
    height: 335.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.23,
    y: 88.277,
    style: {
      fill: "#464655"
    },
    width: 23.54,
    height: 335.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.77,
    y: 88.277,
    style: {
      fill: "#F5F5F5"
    },
    width: 23.54,
    height: 335.45
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF4B55"
    },
    cx: 256,
    cy: 255.997,
    r: 88.28
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M248.421,271.181c0,0-1.031,7.217,5.98,17.938h13.608l-3.093-12.989L248.421,271.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A561CD"
    },
    d: "M247.459,222.868c0,0-22.266,36.425,10.446,58.142l3.436-20.618l2.199-26.666l-3.436-11.409 L247.459,222.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M247.459,222.867c0,0-2.545,4.237-4.653,10.612c2.866,2.996,10.701,6.708,20.335,5.08l0.399-4.834 l-3.437-11.409L247.459,222.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A561CD"
    },
    d: "M243.197,217.645c0,0,0.274-7.285,7.423-7.285c8.935,0,16.22,2.061,27.765,25.978 c0,0-10.269,10.08-16.769-3.849c-1.924-4.124-2.612-9.071-2.612-9.071s-7.972,2.749-13.47-0.413L243.197,217.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M246.771,221.081l-1.65-4.398c0,0-9.209-1.512-5.361,9.622c0,0,0.275-2.199,2.612-1.924 C244.71,224.656,247.183,222.868,246.771,221.081z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M262.165,262.866c0,0-9.689,7.593-4.26,25.428c2.887,9.484,14.432,19.896,14.432,19.896 s8.556-22.37,5.773-31.029C276.472,272.064,262.165,262.866,262.165,262.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M280.584,291.594c0,0-25.016-23.848-26.666-42.61s9.169-15.784,11.134-14.57 C269.725,237.3,281.546,249.396,280.584,291.594z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B34900"
    },
    d: "M277.48,297.057h-41.418c-0.861,0-1.558-0.697-1.558-1.558v-3.07c0-0.861,0.697-1.558,1.558-1.558 h41.418c0.861,0,1.558,0.697,1.558,1.558v3.07C279.037,296.359,278.34,297.057,277.48,297.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M267.389,291.181c-1.442,0.599-4.33,1.341-3.608,3.917c0.553,1.974,4.33,1.752,3.608,4.021 c-0.488,1.533-8.159,1.674-11.134,1.237c-1.822-0.268-5.773-1.341-5.223-5.876c0.551-4.535,2.199-5.234,4.262-6.048 c2.045-0.808,10.99-0.629,12.302,0.481C268.265,289.479,268.481,290.727,267.389,291.181z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256.812,177.133l2.009,6.025l6.35,0.05c0.822,0.007,1.163,1.056,0.502,1.544l-5.109,3.773 l1.916,6.055c0.248,0.783-0.644,1.432-1.313,0.954L256,191.842l-5.166,3.693c-0.669,0.478-1.561-0.17-1.313-0.954l1.916-6.055 l-5.109-3.773c-0.661-0.489-0.32-1.538,0.502-1.544l6.35-0.05l2.009-6.025C255.448,176.354,256.551,176.354,256.812,177.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256.812,317.987l2.009,6.025l6.35,0.05c0.822,0.007,1.163,1.056,0.502,1.544l-5.109,3.773 l1.916,6.055c0.248,0.783-0.644,1.432-1.313,0.954L256,332.695l-5.166,3.693c-0.669,0.478-1.561-0.17-1.313-0.954l1.916-6.055 l-5.109-3.773c-0.661-0.489-0.32-1.538,0.502-1.544l6.35-0.05l2.009-6.025C255.448,317.207,256.551,317.207,256.812,317.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256.812,177.133l2.009,6.025l6.35,0.05c0.822,0.007,1.163,1.056,0.502,1.544l-5.109,3.773 l1.916,6.055c0.248,0.783-0.644,1.432-1.313,0.954L256,191.842l-5.166,3.693c-0.669,0.478-1.561-0.17-1.313-0.954l1.916-6.055 l-5.109-3.773c-0.661-0.489-0.32-1.538,0.502-1.544l6.35-0.05l2.009-6.025C255.448,176.354,256.551,176.354,256.812,177.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256.812,317.987l2.009,6.025l6.35,0.05c0.822,0.007,1.163,1.056,0.502,1.544l-5.109,3.773 l1.916,6.055c0.248,0.783-0.644,1.432-1.313,0.954L256,332.695l-5.166,3.693c-0.669,0.478-1.561-0.17-1.313-0.954l1.916-6.055 l-5.109-3.773c-0.661-0.489-0.32-1.538,0.502-1.544l6.35-0.05l2.009-6.025C255.448,317.207,256.551,317.207,256.812,317.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M207.734,191.589l1.76,6.102l-5.204,3.64c-0.674,0.471-0.36,1.529,0.462,1.556l6.347,0.212 l1.855,6.074c0.241,0.787,1.343,0.814,1.623,0.042l2.163-5.971l6.35,0.114c0.822,0.014,1.19-1.025,0.541-1.53l-5.011-3.902 l2.069-6.006c0.268-0.777-0.608-1.449-1.289-0.988l-5.259,3.56l-5.07-3.823C208.414,190.173,207.505,190.798,207.734,191.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M287.582,307.62l1.76,6.102l-5.204,3.64c-0.674,0.471-0.36,1.529,0.462,1.556l6.347,0.212 l1.855,6.074c0.241,0.787,1.343,0.814,1.623,0.042l2.163-5.971l6.35,0.114c0.822,0.014,1.19-1.025,0.541-1.53l-5.011-3.902 l2.07-6.004c0.268-0.777-0.608-1.449-1.289-0.988l-5.259,3.56l-5.07-3.823C288.264,306.204,287.355,306.831,287.582,307.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M177.885,232.024l5.07,3.823l-1.976,6.036c-0.256,0.781,0.63,1.439,1.304,0.968l5.204-3.641 l5.13,3.744c0.664,0.484,1.564-0.154,1.323-0.941l-1.855-6.073l5.146-3.721c0.666-0.482,0.335-1.535-0.487-1.549l-6.35-0.113 l-1.949-6.045c-0.253-0.782-1.355-0.793-1.623-0.017l-2.069,6.004l-6.35-0.014C177.58,230.483,177.229,231.529,177.885,232.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M311.401,276.888l5.07,3.823l-1.976,6.036c-0.256,0.781,0.63,1.439,1.304,0.968l5.204-3.641 l5.13,3.744c0.664,0.484,1.564-0.154,1.323-0.941l-1.855-6.073l5.146-3.721c0.666-0.482,0.335-1.535-0.487-1.549l-6.35-0.113 l-1.949-6.045c-0.253-0.782-1.355-0.793-1.623-0.017l-2.069,6.004l-6.35-0.014C311.097,275.345,310.745,276.392,311.401,276.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M300.912,191.589l-1.76,6.102l5.204,3.64c0.674,0.471,0.36,1.529-0.462,1.556l-6.347,0.212 l-1.855,6.074c-0.241,0.787-1.343,0.814-1.623,0.042l-2.163-5.971l-6.35,0.114c-0.822,0.014-1.19-1.025-0.541-1.53l5.011-3.902 l-2.07-6.004c-0.268-0.777,0.608-1.449,1.289-0.988l5.259,3.56l5.07-3.823C300.231,190.173,301.14,190.798,300.912,191.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M221.063,307.62l-1.76,6.102l5.204,3.64c0.674,0.471,0.36,1.529-0.462,1.556l-6.347,0.212 l-1.855,6.074c-0.241,0.787-1.343,0.814-1.623,0.042l-2.163-5.971l-6.35,0.114c-0.822,0.014-1.19-1.025-0.541-1.53l5.011-3.902 l-2.07-6.004c-0.268-0.777,0.608-1.449,1.289-0.988l5.259,3.56l5.07-3.823C220.382,306.204,221.291,306.831,221.063,307.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M330.761,232.024l-5.07,3.823l1.976,6.036c0.256,0.781-0.63,1.439-1.304,0.968l-5.204-3.641 l-5.13,3.744c-0.664,0.484-1.564-0.154-1.323-0.941l1.855-6.073l-5.146-3.721c-0.666-0.482-0.335-1.535,0.487-1.549l6.35-0.113 l1.949-6.045c0.253-0.782,1.355-0.793,1.623-0.017l2.069,6.004l6.35-0.014C331.066,230.483,331.418,231.529,330.761,232.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M197.244,276.888l-5.07,3.823l1.976,6.036c0.256,0.781-0.63,1.439-1.304,0.968l-5.204-3.641 l-5.13,3.744c-0.664,0.484-1.564-0.154-1.323-0.941l1.855-6.073l-5.146-3.721c-0.666-0.482-0.335-1.535,0.487-1.549l6.35-0.113 l1.949-6.045c0.253-0.782,1.355-0.793,1.623-0.017l2.069,6.004l6.35-0.014C197.55,275.345,197.901,276.392,197.244,276.888z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.704c3078fd1a706c1f73c2933aeef075.svg";
export { ForwardRef as ReactComponent };